import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import { fireTagManagerEvent } from "../../../assets/Services/tagmanager";
import { GetMetamatchLink } from "../../../assets/TakyonDesignSystem/components/StayRequest/MetamatchLink";
import Button from "../../../assets/TakyonDesignSystem/components/Button/Button";
import { COLLECTION_TYPE } from "../../../assets/models/iCollection";
import { iWallSlot, WALL_SLOT_TYPE } from "../../../config/wall";
import { iNft } from "../../../assets/models/iNft";
import StayRequest from "../../../assets/TakyonDesignSystem/components/StayRequest/StayRequest";
import TakCard from "../../../assets/TakyonDesignSystem/components/TakCard/TakCard";
import { useEffect, useState } from "react";
import NftController from "../../../assets/Controllers/NftController";
import { apiErrorToast } from "../../../assets/Utils/errors";

export default function SecondaryMarket() {
  const { t } = useTranslation();
  const isShortScreen = useMediaQuery({
    query: "only screen and (min-width : 769px) and (max-height : 600px)",
  });
  const mixedTakgetInspired = {
    $or: [
      {
        $and: [
          {
            $or: [
              { "payload.type": { $exists: false } },
              { "payload.type": "hotel" },
              { "payload.type": null },
            ],
          },
          {
            $or: [
              { isHotelFakeSupply: { $exists: false } },
              { isHotelFakeSupply: false },
            ],
          },
        ],
      },
      {
        $and: [
          {
            $or: [
              { "payload.type": { $exists: false } },
              { "payload.type": "hotel" },
              { "payload.type": null },
            ],
          },
          {
            isHotelFakeSupply: true,
          },
        ],
      },
      {
        "payload.type": COLLECTION_TYPE.experience,
      },
    ],
    sellStatus: "FOR_SALE",
  };

  const stays: iWallSlot = {
    title: "secondary.stays_title",
    config: {
      type: WALL_SLOT_TYPE.CLASSIC,
      payload: {
        scroll: false,
        query: mixedTakgetInspired,
        sort: { isHotelFakeSupply: 1 },
      },
    },
  };

  const stayRequest: iWallSlot = {
    title: "secondary.stay_request_title",
    subtitle: "secondary.experiences_btn",
    config: {
      type: WALL_SLOT_TYPE.STAY_REQUEST,
      payload: {},
    },
  };

  const [isLoading, setIsLoading] = useState(true);
  const [nfts, setNfts] = useState<iNft[]>([]);

  const loadNfts = async () => {
    setIsLoading(true);
    try {
      // Use type assertion to access the payload properties
      const payload = stays.config.payload as { sort: any; query: any };

      const data = await NftController.getPaginated({
        page: 1,
        sort: JSON.stringify(payload.sort),
        query: JSON.stringify(payload.query),
      });

      setNfts(data.data);
    } catch (error) {
      apiErrorToast(error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    loadNfts();
  }, []);

  return (
    <div
      className="w100 h100"
      style={{
        minHeight: "100svh",
        marginTop: isShortScreen ? "44px" : "65px",
      }}
    >
      <div className=" h100">
        <div
          className="container d-flex flex-column justify-content-center"
          style={{
            marginTop: "143px",
            marginBottom: "80px",
          }}
        >
          <div className="d-flex flex-column align-items-center justify-content-center pt-4 h1-large white-color regular text-center">
            <p
              className="fs-h1-lg"
              dangerouslySetInnerHTML={{ __html: t("secondary.title") }}
            ></p>
            <p className="primary-color fs-h1-lg">{t("secondary.subtitle")}</p>
            <div
              className="rounded-5 mt-4 mb-5"
              style={{
                padding: "5.021px",
                background:
                  "linear-gradient(93deg, #02FDD2 4.64%, #8CE786 98.99%)",
                width: "fit-content",
              }}
            >
              <Button
                size="sm"
                className="rounded-5 px-2 btn-light-simple"
                onClick={() => {
                  fireTagManagerEvent("metamatch_request");
                  // openSearchModal();
                  window.open(GetMetamatchLink(), "_blank");
                }}
                style={{
                  padding: isShortScreen ? "1px" : "6.021px",
                  backgroundColor: "white",
                  boxShadow: "3.011px 3.011px 3.011px 0px rgba(0, 0, 0, 0.20)",
                }}
                icon={"ai"}
                iconSize={15}
                variant="light"
                text={t("secondary.tellus_btn")}
              />
            </div>
          </div>
        </div>
        <div className="bg-white h100">
          <div className="container d-flex flex-column">
            <div style={{ marginTop: "40px" }}></div>
            <div className="container mb-5 text-black">
              <div className="d-flex flex-column align-items-center justify-content-center gap-2 text-center">
                <p className="fs-h1-lg fw-bolder m-0">{t(stays.title ?? "")}</p>
              </div>
            </div>
            <div className="d-flex justify-content-center">
              {isLoading ? (
                <div className="text-center">
                  <p>Loading...</p>
                </div>
              ) : (
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, 310px)",
                    gap: "24px",
                    justifyContent: "center",
                    maxWidth: "100%",
                  }}
                >
                  {nfts.map((item, key) => (
                    <div
                      key={`takcard_${key}`}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <TakCard nft={item} key={`slot_${key}`} />
                    </div>
                  ))}
                </div>
              )}
            </div>
            <StayRequest slot={stayRequest} />
            <div style={{ marginTop: "80px" }}></div>
          </div>
        </div>
      </div>
    </div>
  );
}
